<template>
  <div style="margin-top: 5px">
    <div id="menu" style="text-align: center">
      <button :disabled="selectedCards.length == 0 || viewGameBoard" @click="start" type="button" class="btn btn-dark btn-lg">Play {{ viewGameBoard ? "" : "with " + selectedCards.length }} cards</button>
      <button @click="configure" type="button" class="btn btn-dark btn-lg">Config</button>
    </div>
    <div id="config" class="container" v-if="viewConfig">
      <div>
        <ul>
          <li v-for="(card, index) in cards">
            <div class="configurationCards">
              <label :for="'conf-' + index">
                <img :src="card.image" height="140px" width="175px"/>
                <p>{{card.name}}</p>
              </label>
              <div>
                <input :id="'conf-' + index" type="checkbox" v-model="card.selectedCard" >
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div style="text-align: center">
        <button @click="save" class="btn btn-dark btn-lg">Save</button>
      </div>
    </div>
    <div v-if="viewGameBoard" id="flashcard-app" class="container" :class="{blockCursor: block}">
      <ul class="flashcard-list">
        <li class="matchingCards" v-on:click="toggleCard(card)" v-for="(card, index) in boardCards">
          <transition name="flip"><app-matching-card :card="card"></app-matching-card></transition>
        </li>
      </ul>
    </div>
    <app-card-matched v-if="matched" :card="matchedCard"></app-card-matched>
  </div>
</template>

<script>
  import MatchingCard from './app-matching-card';
  import AppCardMatched from "./app-card-matched";

  export default {
    name: "app-matching",
    components: {
      appCardMatched: AppCardMatched,
      appMatchingCard: MatchingCard
    },
    props: {
      pageconfig: {requite: true}
    },
    data: function () {
      return {
        mConfig: this.pageconfig,
        cards: [],
        selectedCards: [],
        boardCards: [],
        newFront: '',
        newBack: '',
        compare: false,
        selected: '',
        block: false,
        matched: false,
        matchedCard: {},
        viewConfig: false,
        viewGameBoard: false
      }
    },
    mounted: function () {
      this.mConfig.forEach((element) => {
        this.cards.push(
          {
            image: element.image,
            name: element.name,
            selectedCard: false
          }
        );
      });
    },
    methods: {
      start() {
        this.boardCards = [];

        this.selectedCards.forEach((element) => {
          element.added = 0;
        });

        while (this.selectedCards.length > 0) {
          let index = Math.floor(Math.random() * (this.selectedCards.length));
          this.boardCards.push({
            flipped: false,
            matched: false,
            image: this.selectedCards[index].image,
            name: this.selectedCards[index].name
          });
          if (this.selectedCards[index].added == 1) {
            this.selectedCards.splice(index, 1);
          } else {
            this.selectedCards[index].added = 1;
          }
        }
        this.viewGameBoard = true;
      },

      configure() {
        this.viewConfig = true;
        this.viewGameBoard = false;
      },

      save() {
        this.selectedCards = [];
        this.cards.forEach((element) => {
          if (element.selectedCard) {
            this.selectedCards.push(element);
          }
        });

        if (this.selectedCards.length <= 1) {
          alert("Al menos 2 cartas deben estar seleccionadas");
        } else {
          this.viewConfig = false;
        }
      },

      toggleCard: async function (card) {
        if (!this.block) {
          if (!card.flipped) {
            card.flipped = !card.flipped;
            if (this.compare) {
              if (this.selected == card.name) {
                this.doMatch();
              } else {
                this.selected = '';
                this.block = true;
                await this.sleep(3500);
                this.flipBack();
              }
            } else {
              this.selected = card.name;
            }
            this.compare = !this.compare;
          }
        }
      },
      flipBack: function () {
        this.boardCards.forEach((element) => {
          if (element.matched == false && element.flipped == true) {
            element.flipped = false;
          }
        });
        this.block = false;
      },
      sleep: function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      },
      doMatch: function () {
        this.boardCards.forEach((element) => {
          if (element.name == this.selected) {
            element.matched = true;
            this.matchedAnimation(element);
          }
        });
      },
      matchedAnimation: async function (card) {
        this.block = true;
        this.matched = true;
        this.matchedCard = card;
        await this.sleep(4900);
        this.matched = false;
        this.matchedCard = {};
        this.block = false;
      }
    }
  }
</script>

<style scoped>
  ul {
    padding-left: 0;
    display: flex;
    flex-flow: row wrap;
  }

  li {
    list-style-type: none;
    padding: 10px 10px;
    transition: all 0.3s ease;
  }

  .container {
    max-width: 100%;
    padding: 0.5em 2rem 2rem 2rem;
  }

  .matchingCards:hover{
    transform: scale(1.1);
  }

  .blockCursor {
    cursor: not-allowed;
  }

  .configurationCards {
    background-color: #302f30;
    border-radius: 7px;
    text-align: center;
    cursor: pointer;
    color: #fff;
    padding: 5px;
  }

  .configurationCards p {
    margin: 0px;
  }

  .configurationCards label {
    margin: 0px;
  }

</style>



// WEBPACK FOOTER //
// src/components/app-matching.vue